import { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col } from "antd";
import SelectArrow from "../../../../components/selectArrow";
import { useOutsideAlerter } from "../../../../hooks/utils";
import { allRoles, genres } from "../../../../assets/constants";
import connectionActions from "../../../../redux/connections/actions";
import styles from "./style.module.scss";

const Header = () => {
  const dispatch = useDispatch();
  const rolesRef = useRef(null);
  const genreRef = useRef(null);
  const locationRef = useRef(null);

  const { locations = ["Londan", "Berlin", "Rabat"] } = useSelector(
    (state) => ({
      locations: state.connection.locations,
    })
  );

  const [showRoles, setShowRoles] = useState(false);
  const [showGenres, setShowGenres] = useState(false);
  const [showLocations, setShowLocations] = useState(false);
  const [selectedRole, setSelectedRole] = useState();
  const [selectedGenre, setSelectedGenre] = useState();
  const [selectedLocation, setSelectedLocation] = useState();

  useOutsideAlerter(rolesRef, setShowRoles);
  useOutsideAlerter(genreRef, setShowGenres);
  useOutsideAlerter(locationRef, setShowLocations);

  useEffect(() => {
    dispatch({
      type: connectionActions.SET_STATE,
      payload: {
        filters: {
          role: selectedRole?.toLowerCase(),
          genre: selectedGenre?.toLowerCase(),
          location: selectedLocation?.toLowerCase(),
        },
      },
    });
  }, [selectedRole, selectedGenre, selectedLocation]);

  const onChangeRole = (role) => {
    setSelectedRole(role);
    setShowRoles(false);
  };

  const onChangeGenre = (genre) => {
    setSelectedGenre(genre);
    setShowGenres(false);
  };

  const onChangeLocation = (location) => {
    setShowLocations(false);
    setSelectedLocation(location);
  };

  return (
    <Row className={styles.container} justify="space-between" align="top">
      <Col span={6} className={styles.elementContainer}>
        <p>
          Role <span>*</span>
        </p>
        <div className={styles.select} ref={rolesRef}>
          <div
            className={styles.selectedType}
            onClick={() => setShowRoles(true)}
          >
            <div className={styles.select}>{selectedRole}</div>
            <SelectArrow />
          </div>
          {showRoles && (
            <div className={styles.options}>
              {allRoles
                .sort((a, b) => (a.toLowerCase() > b.toLowerCase() ? 1 : -1))
                .map((role) => (
                  <div
                    key={role}
                    className={styles.option}
                    onClick={() => onChangeRole(role)}
                  >
                    {role}
                  </div>
                ))}
            </div>
          )}
        </div>
      </Col>
      <Col span={6} className={styles.elementContainer}>
        <p>Genre</p>
        <div className={styles.select} ref={genreRef}>
          <div
            className={styles.selectedType}
            onClick={() => setShowGenres(true)}
          >
            <div className={styles.select}>{selectedGenre}</div>
            <SelectArrow />
          </div>
          {showGenres && (
            <div className={styles.options}>
              {genres
                .sort((a, b) => (a.toLowerCase() > b.toLowerCase() ? 1 : -1))
                .map((genre) => (
                  <div
                    key={genre}
                    className={styles.option}
                    onClick={() => onChangeGenre(genre)}
                  >
                    {genre}
                  </div>
                ))}
            </div>
          )}
        </div>
      </Col>
      <Col span={6} className={styles.elementContainer}>
        <p>Location</p>
        <div className={styles.select} ref={locationRef}>
          <div
            className={styles.selectedType}
            onClick={() => setShowLocations(true)}
          >
            <div className={styles.select}>{selectedLocation}</div>
            <SelectArrow />
          </div>
          {showLocations && (
            <div className={styles.options}>
              {locations
                .sort((a, b) => (a.toLowerCase() > b.toLowerCase() ? 1 : -1))
                .map((location) => (
                  <div
                    key={location}
                    className={styles.option}
                    onClick={() => onChangeLocation(location)}
                  >
                    {location}
                  </div>
                ))}
            </div>
          )}
        </div>
      </Col>
    </Row>
  );
};

export default Header;
